<template>
	<div class="site-footer">
		<div class="site-footer-main">
			<div>
				<el-image class="site-footer-logo" src="http://www.smnks.com.cn/public/smnks/images/lgdb.png"
					mode="widthFix"></el-image>
				<el-image class="site-footer-small-blue" src="https://dcs.conac.cn/image/blue.png" mode="widthFix"
					v-if="this.screenWidth < 768"></el-image>
			</div>
			<div class="site-footer-info">
				<div>主办：三明市农科院 承办：三明市农科院科研处</div>
				<div>备案号：[ <a href="https://beian.miit.gov.cn/" target="_blank">闽ICP备17025109号</a> ]
				</div>
				<div>地址：福建省沙县虬江街道办柱源村 邮编：365509 Email:info@smnks.com.cn</div>
				<div>版权所有：三明市农科院 中文域名：三明市农科院.公益</div>
			</div>
			<el-image class="site-footer-blue" src="https://dcs.conac.cn/image/blue.png" mode="widthFix"
				v-if="this.screenWidth > 768"></el-image>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'site-footer',
		data() {
			return {
				screenWidth: 0
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getScreenChange();
				window.addEventListener('resize', () => {
					this.getScreenChange()
				})
			})
		},
		methods: {
			getScreenChange() {
				const clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
				this.screenWidth = clientWidth;
			}
		}
	}
</script>

<style lang="scss">
	@import "@/assets/styles/theme.scss";

	.site-footer {
		padding: .625rem
			/* 10/16 */
		;
		min-width: 75rem;
		background-color: $theme-color;

		.site-footer-main {
			width: 75rem;
			margin: 0 auto;
			display: flex;
			color: #FFFFFF;
			align-items: flex-start;
			gap: 1.25rem
				/* 20/16 */
			;

			a {
				color: #FFFFFF;
				text-decoration: none;
			}

			.site-footer-logo {
				width: 18.75rem
					/* 300/16 */
				;
			}

			.site-footer-info {
				flex: 1;
				font-size: .8125rem
					/* 13/16 */
				;
				line-height: 1.8em;
			}

			.site-footer-blue {
				width: 3.75rem
					/* 60/16 */
				;
			}

			.site-footer-small-blue {
				margin-left: 1.25rem
					/* 20/16 */
				;
				width: 2.5rem
					/* 40/16 */
				;
			}
		}
	}

	@media (max-width: 768px) {
		.site-footer {
			min-width: unset;
			padding: 1.25rem
				/* 20/16 */
				3.125rem
				/* 50/16 */
			;
			background-color: $theme-color;

			.site-footer-main {
				width: 100%;
				margin: 0 auto;
				display: flex;
				flex-direction: column;
				color: #FFFFFF;

				a {
					color: #FFFFFF;
					text-decoration: none;
				}

				.site-footer-logo {
					width: 15.625rem
						/* 250/16 */
					;
				}

				.site-footer-info {
					flex: 1;
					font-size: .8125rem
						/* 13/16 */
					;
					line-height: 1.8em;
				}

				.site-footer-blue {
					width: 3.75rem
						/* 60/16 */
					;
				}
			}
		}
	}
</style>